// extracted by mini-css-extract-plugin
export default {"card":"card__NTBY0"};